var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "usp-box mdc-typography mdc-typography mdc-typography--body2"
    },
    [
      _c("hr", { staticClass: "usp-box__separator" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "usp-box__content" },
        _vm._l(_vm.usp, function(item) {
          return _c("p", { staticClass: "usp-box__content__argument" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(item))])
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }